import { render, staticRenderFns } from "./EditInput.vue?vue&type=template&id=24a5023c&scoped=true&lang=pug"
import script from "./EditInput.vue?vue&type=script&lang=js"
export * from "./EditInput.vue?vue&type=script&lang=js"
import style0 from "./EditInput.vue?vue&type=style&index=0&id=24a5023c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a5023c",
  null
  
)

export default component.exports